import React, { Component } from 'react';
import {Spacer, Button, InputInline} from 'app/components/Basics/'
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import './GlobalControlLineComponent.scss';
import { ReactComponent as SaveIcon } from 'app/assets/icons/Save.svg';
import { ReactComponent as DuplicateIcon } from 'app/assets/icons/Duplicate-Plus.svg';
import {QuotaFormContext} from '../../QuotaContext'
import ValidateQuota from '../../QuotaValidation'
 
class GlobalControlLine extends Component {

    constructor(props){
        super(props);

        this.state = {            
        }        
    }

    componentWillReceiveProps(nextProps) {        
        if (nextProps && nextProps.errors) {            
            var error = nextProps.errors.find(e => e.field === "name")
            if (error) {
                this.setState({errorQuotaName: error.errorMessage})
            }
        }
    }

    getNewQuotaName(isEditorOpen, newQuotaName) {
        if (!isEditorOpen) {
            var selectedQuota = this.context.selectedQuota;
            selectedQuota.name = newQuotaName;
            this.context.updateSelectedQuota(selectedQuota);
        }
    }
	
	isSaveDisabled() {
		let result = false;
		var errors = ValidateQuota(this.context.selectedQuota);		
		if (errors.length > 0) {
			result = true;
		}		
		if (!this.props.didSelectedQuotaChange()) {
			result = true;
		}
		return result;
	}

	isNewQuota() {
		return this.context.selectedQuota.id === null;
	}	

	userCannotChangeData() {
		return !this.props.canChangeData;
	}

    render() {
        return (
            <div className="GlobalControlLineComponent form-row">
                <InputInline disabled={this.userCannotChangeData()} enableOnBlur className="name-field" error={this.state.errorQuotaName} value={this.context.selectedQuota.name} onModeChange={this.getNewQuotaName.bind(this)} />
                <div className="contol-buttons">                    
                    <Button disabled={this.userCannotChangeData() || this.isSaveDisabled()} title="Save all changes in the survey" icon={<SaveIcon/>} onClick={this.props.handleSubmitAction}>Save</Button>                    
                    <Button title="Close current editor and discard all unsaved changes" onClick={this.props.closeEditorButtonOnClick} simple icon={Icons.Close}>Close</Button>
                    <Spacer width={20}/>                   
                    <Button disabled={this.userCannotChangeData() || this.isNewQuota()} title="Delete the survey is irreversible" small secondary icon={Icons.Delete} onClick={this.props.deleteQuota}>Delete</Button>
                    <Button disabled={this.userCannotChangeData() || this.isNewQuota()} title="Create a new survey as duplicate from this survey" small secondary icon={<DuplicateIcon/>} onClick={this.props.duplicateQuota}>Duplicate</Button>					
                </div>
                
            </div>  
        );
    }
}
GlobalControlLine.contextType = QuotaFormContext;
export default GlobalControlLine;